import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guid: null,
  title: null,
};

export const selectedAccessibleFarmerDashboardSlice = createSlice({
  name: "selectedAccessibleFarmerDashboard",
  initialState,
  reducers: {
    setSelectedAccessibleFarmerDashboard: (state, action) => {
      state.guid = action.payload.guid;
      state.title = action.payload.title;
    },
  },
});

export const { setSelectedAccessibleFarmerDashboard } =
  selectedAccessibleFarmerDashboardSlice.actions;

export const selectedAccessibleFarmerDashboardReducer =
  selectedAccessibleFarmerDashboardSlice.reducer;
